import {
  InteractionLayer as InteractionLayerComponent,
  type InteractionLayerSizeValue,
  type WithFocusLockProps,
  withFocusLock,
} from '@volkswagen-onehub/components-core';
import {
  type InteractionLayerOptionsV2,
  InteractionLayerSizeV2,
  type LayerV2,
} from '@volkswagen-onehub/layer-manager';
import * as React from 'react';
import ReactDOM from 'react-dom';

import {LayerContent} from './layer-content';

export interface InteractionLayerProps {
  readonly layer: LayerV2<unknown, InteractionLayerOptionsV2>;
  readonly active: boolean;
  scrollElementRef(el: HTMLDivElement): void;
}

const layerSizeMap: {
  [key in InteractionLayerSizeV2]: InteractionLayerSizeValue;
} = {
  [InteractionLayerSizeV2.A]: 'A',
  [InteractionLayerSizeV2.B]: 'B',
  [InteractionLayerSizeV2.C]: 'C',
  [InteractionLayerSizeV2.D]: 'D',
  [InteractionLayerSizeV2.E]: 'E',
};

const Layer: React.FunctionComponent<InteractionLayerProps> = (props) => {
  const {layer, active, scrollElementRef, ...ownProps} = props;
  const {options} = layer;

  return (
    <InteractionLayerComponent
      {
        ...ownProps /* Used to pass through the animation props */
      }
      size={layerSizeMap[options.size]}
      active={active}
      scrollElementRef={(el: HTMLDivElement) => {
        scrollElementRef(ReactDOM.findDOMNode(el) as HTMLDivElement);
      }}
      aria-labelledby={options['aria-labelledby']}
    >
      <LayerContent layer={layer} />
    </InteractionLayerComponent>
  );
};

const InteractionLayerWithLock = withFocusLock<InteractionLayerProps>(Layer);
InteractionLayerWithLock.displayName = 'InteractionLayerWithLock';

export const InteractionLayer: React.ElementType = (
  props: InteractionLayerProps & WithFocusLockProps,
) => {
  return (
    <InteractionLayerWithLock {...props} disabled={props.layer.isClosed} />
  );
};
